import { render } from "./DropFile.vue?vue&type=template&id=9edc5bf0&scoped=true"
import script from "./DropFile.vue?vue&type=script&lang=js"
export * from "./DropFile.vue?vue&type=script&lang=js"

import "./DropFile.vue?vue&type=style&index=0&id=9edc5bf0&lang=scss&scoped=true"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9edc5bf0"]])

export default __exports__